export default __webpack_public_path__ + "static/media/logo-volta-new-white.63c2970e.png";